export const compareArraysByProperty = <T>(arr1: any[], arr2: any[], propertyName: string): boolean => {
  if(!arr1 || !arr2) {
    return false;
  }
// If the arrays have different lengths, they can't be the same
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Create a map from the first array based on the propertyName
  const map1 = new Map<any, any>();
  arr1.forEach(obj => map1.set(obj[propertyName], obj));

  // Check if each object in the second array exists in the map based on the propertyName
  for (let obj of arr2) {
    if (!map1.has(obj[propertyName])) {
      return false; // If a property value from arr2 doesn't exist in arr1, they aren't the same
    }
  }

  return true;  // All property values are matched
}